<template>
    <div class="class condiciones0">
        <b-container class="mt-3">
            <div class="row mt-3">
                <div class="tab-content col-10 mx-auto pt-4" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="manual-operativo" role="tabpanel"
                        aria-labelledby="manual-operativo-tab">
                        <!-- Comienzo cajas manuales e instrucciones -->
                        <div class="container-grid">
                            <a href="pdf/manual_operativo_castellon.pdf" target="_blank">
                                <div class="box d-flex lift p-3">
                                    <div class="box-icon">
                                        <img :src="require('@/assets/css/img/icon-pdf.svg')" alt="">
                                    </div>
                                    <div class="box-content ml-2">
                                        <div class="h7 text-primary">Manual Operativo</div>
                                        <div class="h7 text-secondary">Programa Castellón Senior</div>
                                    </div>
                                </div>
                            </a>
                            <a href="pdf/cartel_agencia_castellon.pdf" target="_blank">
                                <div class="box d-flex lift p-3">
                                    <div class="box-icon">
                                        <img :src="require('@/assets/css/img/icon-pdf.svg')" alt="">
                                    </div>
                                    <div class="box-content ml-2">
                                        <div class="h7 text-primary">Cartel Programa Agencia Autorizada</div>
                                        <div class="h7 text-secondary">Programa Castellón Senior</div>
                                    </div>
                                </div>
                            </a>
                            <!-- <a href="pdf/manual_aplicacion_castellon.pdf" target="_blank">
                                <div class="box d-flex lift p-3">
                                    <div class="box-icon">
                                        <img :src="require('@/assets/css/img/icon-pdf.svg')" alt="">
                                    </div>
                                    <div class="box-content ml-2">
                                        <div class="h7 text-primary">Manual Aplicación Informática</div>
                                        <div class="h7 text-secondary">Programa Castellón Senior</div>
                                    </div>
                                </div>
                            </a>
                            <a href="pdf/normas_generales_castellon.pdf" target="_blank">
                                <div class="box d-flex lift p-3">
                                    <div class="box-icon">
                                        <img :src="require('@/assets/css/img/icon-pdf.svg')" alt="">
                                    </div>
                                    <div class="box-content ml-2">
                                        <div class="h7 text-primary">Información General</div>
                                        <div class="h7 text-secondary">Normas Generales</div>
                                    </div>
                                </div>
                            </a> -->
                        </div>
                        <!-- Fin cajas manuales e instrucciones -->
                    </div>
                </div>
            </div>
        </b-container>
    </div>
</template>

<script>

//import MenuOpcion from '@/components/MenuOpcion.vue'

export default {
    name: 'manuales',
    components: {
        //MenuOpcion,
    },

    data() {
        return {
            titulo: "MANUAL OPERATIVO",
        }
    },

}
</script>